import type {SocialAccount} from '@Components/social-media/account.vo';

export const YOUTUBE_SHORTS_ACTION_ICONS: string[] = ['icon-heart', 'icon-message', 'icon-share-external', 'icon-refresh'];

export interface YoutubeOverlayProps {
  account: SocialAccount;
  caption: string;
}
